import { Checkbox as NativeCheckbox } from '@mantine/core';
import classes from './Checkbox.module.css';

export const Checkbox = (props: {
	onClick?: () => void;
	size: string;
	label: string;
	placeholder?: string;
	variant?: string;
	checked: boolean;
	withAsterisk?: boolean;
	error?: string;
	disabled?: boolean;
}) => {
	return (
		<NativeCheckbox classNames={classes} {...props} />
	);
};
